"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var PageButton_1 = __importStar(require("./PageButton"));
var Pagination = function (props) {
    var showPrevNext = props.showPrevNext, className = props.className, _a = props.boundaryRange, boundaryRange = _a === void 0 ? 2 : _a, _b = props.collapse, collapse = _b === void 0 ? true : _b, totalPages = props.totalPages, activePage = props.activePage, _c = props.siblingRange, siblingRange = _c === void 0 ? 1 : _c, onPageChange = props.onPageChange, _d = props.pageButtonFn, pageButtonFn = _d === void 0 ? function (props) { return react_1.default.createElement(PageButton_1.default, __assign({}, props)); } : _d, pageUrlPrefix = props.pageUrlPrefix, pageUrlSuffix = props.pageUrlSuffix, _e = props.minPagesToShow, minPagesToShow = _e === void 0 ? 2 : _e, modal = props.modal;
    var _f = (0, react_1.useState)(false), modalActive = _f[0], setModalActive = _f[1];
    if (totalPages < minPagesToShow)
        return null;
    var paginationModal = modal &&
        react_1.default.cloneElement(modal, {
            active: modalActive,
            closeModal: function () { return setModalActive(false); },
        });
    var pagesObjects = [];
    var createPageButtonObject = function (i) {
        if (!i) {
            return {
                type: PageButton_1.PageButtonType.ELLIPSIS,
            };
        }
        return {
            isActive: activePage === i,
            page: i,
        };
    };
    var createEllipsisBetween = function (aPart, bPart) {
        var _a;
        if (aPart.length === 0 || bPart.length === 0) {
            return [];
        }
        var lastPartA = (_a = aPart[aPart.length - 1].page) !== null && _a !== void 0 ? _a : 0;
        var firstPartB = bPart[0].page;
        if (lastPartA + 1 !== firstPartB) {
            return [createPageButtonObject()];
        }
        return [];
    };
    var firstPage = 1;
    if (collapse && totalPages > 3) {
        /**
           Props:
           - Active page: 10
           - Total pages: 50
           - Boundary pages range: 2 | ex. 1,2 & 49,59
           - Siblings pages range: 1 | ex. 9,11
    
           Pagination Demo:
           << < 1 2 ... 9 [10] 11 ... 49 50 > >>
           ^     ^      ^       ^
           |     |      |       |
           startMax siblingMin/Max endMin
           */
        var siblingMin = activePage - siblingRange > firstPage ? activePage - siblingRange : firstPage; // ex. 9
        var siblingMax = activePage + siblingRange < totalPages ? activePage + siblingRange : totalPages; // ex. 11
        var startMax = boundaryRange <= siblingMin ? boundaryRange : siblingMin; // ex. 2
        var endMin = totalPages - boundaryRange + 1 >= siblingMax ? totalPages - boundaryRange + 1 : siblingMax; // ex. 49
        var _g = [[], [], []], firstPart = _g[0], secondPart = _g[1], thirdPart = _g[2];
        // generate 1/3 part of the pagination
        for (var i = firstPage; i <= startMax; i += 1) {
            if (i < siblingMin) {
                firstPart.push(createPageButtonObject(i));
            }
        }
        // generate 2/3 part of the pagination
        for (var i = siblingMin; i <= siblingMax; i += 1) {
            secondPart.push(createPageButtonObject(i));
        }
        // generate 3/3 part of the pagination
        for (var i = endMin; i <= totalPages; i += 1) {
            // if (!(endMin === totalPages && endMin === i) && !(endMin === activePage && activePage === i) && !(endMin === totalPages && endMin === i)) {
            if (i > siblingMax) {
                thirdPart.push(createPageButtonObject(i));
            } // prevents overlap
        }
        pagesObjects = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], firstPart, true), createEllipsisBetween(firstPart, secondPart), true), secondPart, true), createEllipsisBetween(secondPart, thirdPart), true), thirdPart, true);
    }
    else {
        for (var i = firstPage; i <= totalPages; i += 1) {
            pagesObjects.push(createPageButtonObject(i));
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)('man-ui text-center', className) },
            react_1.default.createElement("nav", { className: "pagination" },
                showPrevNext &&
                    totalPages > 1 &&
                    pageButtonFn({
                        isActive: false,
                        type: PageButton_1.PageButtonType.PREV,
                        page: activePage > 1 ? activePage - 1 : activePage,
                        key: 0,
                        onPageChange: onPageChange,
                        pageUrlPrefix: pageUrlPrefix,
                        pageUrlSuffix: pageUrlSuffix,
                    }),
                pagesObjects.map(function (_a, index) {
                    var isActive = _a.isActive, type = _a.type, page = _a.page;
                    return pageButtonFn({
                        isActive: isActive,
                        type: type,
                        page: page,
                        key: index,
                        onPageChange: onPageChange,
                        onEllipsisClick: function () { return setModalActive(true); },
                        pageUrlPrefix: pageUrlPrefix,
                        pageUrlSuffix: pageUrlSuffix,
                    });
                }),
                showPrevNext &&
                    totalPages > 1 &&
                    pageButtonFn({
                        isActive: false,
                        type: PageButton_1.PageButtonType.NEXT,
                        page: activePage === totalPages ? activePage : activePage + 1,
                        key: totalPages + 1,
                        onPageChange: onPageChange,
                        pageUrlPrefix: pageUrlPrefix,
                        pageUrlSuffix: pageUrlSuffix,
                    }))),
        paginationModal));
};
exports.Pagination = Pagination;
exports.default = exports.Pagination;
